// src/pages/InProgress.tsx
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/InProgress.css';

const InProgress: React.FC = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const moduleName = state?.module || 'Unknown Module';

  const goBack = () => {
    navigate('/home');
  };

  return (
    <div className="full-background">
      <video autoPlay muted loop playsInline className="bg-video">
        <source src="/assets/bgvideo.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="in-progress-container">
        <h1>{moduleName}</h1>
        <p>This module is currently in progress.</p>
        <button onClick={goBack} className="back-button">← Go to Home</button>
      </div>
    </div>
  );
};

export default InProgress;
